import { render, staticRenderFns } from "./ClientDetail.vue?vue&type=template&id=b49ffe32&"
import script from "./ClientDetail.vue?vue&type=script&lang=js&"
export * from "./ClientDetail.vue?vue&type=script&lang=js&"
import style0 from "./ClientDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports